import * as React from 'react';
import { connect } from 'react-redux';
import * as Moment from 'moment';
import { CalendarAppState } from '../classes/redux-states';
import { Dispatch } from 'redux';
import { IAAPDEvent } from '../classes/event';
import { ActionType, setContent } from '../redux/actions/actions';

export interface ExternalProps {
    event: IAAPDEvent;
}

interface DispatchToProps {
    setContent: (content: IAAPDEvent) => any;
}

export interface StateToProps {
}

interface GridItemState {
}

type GridItemProps = ExternalProps & DispatchToProps & StateToProps;

export class GridItemComponent extends React.Component<GridItemProps, GridItemState> {
    constructor(props: GridItemProps) {
        super(props);
    }

    render() {
        if (!this.props.event.allDayEvent) {
            return (
                <li className="calendar-grid-event">
                    <h4 className="calendar-grid-event-time">{Moment(this.props.event.startDateTime).format("h:mm A")} &ndash; {Moment(this.props.event.endDateTime).format("h:mm A")}</h4>
                    <h5 className="calendar-grid-event-title"><a className="calendar-grid-event-title-link" href={this.props.event.eventLink}>{this.props.event.eventName}</a></h5>
                </li >
            )
        }
        else {
            return (
                <li className="calendar-grid-event">
                    <h4 className="calendar-grid-event-time">All Day Event</h4>
                    <h5 className="calendar-grid-event-title"><a className="calendar-grid-event-title-link" href={this.props.event.eventLink}>{this.props.event.eventName}</a></h5>
                </li >
            )
        }
    }
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>, ownProps: ExternalProps): DispatchToProps {
    return {
        setContent: (content: IAAPDEvent) => dispatch(setContent(content))
    }
}

export default connect(null, mapDispatchToProps)(GridItemComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-grid-event.tsx